import { PharmaciesNoteGroupsAddNote } from '@components/pharmaciesNoteGroups/PharmaciesNoteGroupsAddNote';
import { AddCorrectionNote } from '@components/pharmacyNote/correctionNote/AddCorrectionNote';
import { AddLossNote } from '@components/pharmacyNote/lossNote/AddLossNote';
import { BackButton } from '@components/shared/buttons/BackButton';
import { useRootData } from '@hooks/hook';
import { DictionariesConstants } from '@services/DictionariesConstants';
import { PharmacyTaxNoteGroupDto } from '@services/src/models';
import { Button, Col, Divider, Row, Space, Switch } from 'antd';
import React from 'react';
import { useHistory } from 'react-router';
import { IDictionaryStore } from 'stores/DictionaryStore';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { ManualOperationsModal } from './manualOperation/ManualOperationsModal';
import { AddReturnDocumentModal } from './pharmaciesReturnDocuments/AddReturnDocument';
import styles from './styles/PharmacyNotes.module.less';
import { ajaxByUser } from '@helper/api';
import { getEssityApiClient } from '@services/EssityApi';

interface IProps {
	noteGroup: PharmacyTaxNoteGroupDto;
}

export const PharmacyNotesMenu = (props: IProps) => {
	const group = props.noteGroup;

	const dictionaryStore: IDictionaryStore = useRootData(
		(store) => store.dictionaryStore
	);

	const history = useHistory();

	const getHeader = () => {
		return `${group.pharmacyName} (${dictionaryStore.getValueById(
			DictionariesConstants.Voivodeships,
			group.voivodeshipId!
		)}, ${group.placeId}) ${group.month}/${group.year}`;
	};
	const [isBlocked, setIsBlocked] = React.useState(group.isBlocked ?? false);
	const actionsBlocked = group.automaticNoteProcessing ?? false;
	console.log(group);
	return (
		<>
			<Divider />
			<Space direction="vertical" className={styles.menu}>
				<h2 >{getHeader()}</h2>
				{actionsBlocked && <h3 className="important-message">Credit notes are being generated</h3>}

				<Space direction="horizontal">
					<BackButton
						customAction={() => history.push('/pharmacyPayments')}
					/>
					<PharmaciesNoteGroupsAddNote
						pharmacyId={props.noteGroup.pharmacyId}
						disabled={actionsBlocked}
					/>
					<AddCorrectionNote
						noteGroupId={props.noteGroup.id!}
						disabled={actionsBlocked}
					/>
					<AddLossNote
						noteGroupId={props.noteGroup.id!}
						disabled={actionsBlocked}
					/>
					<ManualOperationsModal
						noteGroupId={props.noteGroup.id!}
						disabled={actionsBlocked}
					/>
					<AddReturnDocumentModal
						pharmacyId={props.noteGroup.pharmacyId!}
						year={props.noteGroup.year!}
						month={props.noteGroup.month!}
						pharmacyTaxNoteGroupId={props.noteGroup.id!}
						disabled={actionsBlocked}

					/>

					{group.automaticNoteSending && group.noteValue === 0 && (
						<Row align="middle" gutter={[10, 0]}>
							<Col>
								<label>Is blocked</label>
							</Col>
							<Col>
								<Switch
									checked={isBlocked}
									checkedChildren={<CheckOutlined />}
									unCheckedChildren={<CloseOutlined />}
									disabled={actionsBlocked}
									onChange={(checked) => {
										setIsBlocked(checked)
										ajaxByUser((checked ? 'Successfully blocked note' : 'Successfully unblocked note'), () =>
											getEssityApiClient().then((api) =>
												api.pharmacyTaxNoteGroup
													.blockNote({
														body: {
															pharmacyTaxNoteGroupIds: [props.noteGroup.id!],
														}
													})

											)
										)
									}
									}
								/>
							</Col>
						</Row>
					)}

				</Space>
			</Space>

			<Divider />
		</>
	);
};
